<svelte:head>
  <link rel="canonical" href="https://squid.software/#/solutions" />
</svelte:head>

<div class="solutions">
  <h1>Solutions</h1>

  <div class="flex">
    <div>
      <img src="/icons/plan-large.png" alt="plan-icon" class="icon" />
      <h2>Squid Truckplanning</h2>
      <p>
        Squid Truckplanning integrates with your existing systems and helps you plan your trucks
        more efficiently.
      </p>
      <p>
        We achieve this by effective data management and smart algorithms to help planners create
        the best possible planning.
      </p>
      <h3>Pricing: On request</h3>
    </div>

    <div>
      <img src="/icons/route-large.png" alt="route-icon" class="icon" />
      <h2>Squid OSRM Truckrouting</h2>
      <p>
        Google Maps has its uses, but estimating truck driving duration is not one of them.
        Truckrouting calculates the distance over the road and the expected duration of driving that
        distance by truck.
      </p>

      <h3>Documentation</h3>
      <p>
        Squid OSRM Truckrouting is an HTTP API that makes use of <a
          href="https://deflog.nl/marketplace/1c74c0e7038d4aae874d68fcc024ca69/overview"
          target="_blank">DEFLog</a
        > for authentication.
      </p>
      <p>
        You can query the routing endpoint of Squid OSRM Truckrouting by providing a list of
        GPS-coordinates and you'll soon receive the distance and expected driving duration back.
      </p>
      <p>
        <a href="http://osrm.squid.software/docs" target="_blank"
          >Read the full documentation here</a
        >
      </p>

      <h3>Pricing</h3>
      <table>
        <thead>
          <tr>
            <th class="right">Number of requests</th>
            <th class="left">Price per month</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="right">0 - 1.000</td>
            <td class="left">Free</td>
          </tr>
          <tr>
            <td class="right">1.000 - 10.000</td>
            <td class="left">€ 20,00 (ex. BTW)</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <img src="/icons/location-large.png" alt="location-icon" class="icon" />
      <h2>Squid Geocoder</h2>
      <p>
        Geocoder is made for you if you need a fast and easy way to convert your addresses into
        GPS-coordinates.
      </p>

      <h3>Documentation</h3>
      <p>
        Squid Geocoder is an HTTP API that makes use of <a
          href="https://data.deflog.nl/marketplace/44df2bab823548bbadd555e7abef86e3/overview"
          target="_blank">DEFLog</a
        > for authentication.
      </p>
      <p>
        You can query Squid Geocoder with one or any combination of the follosing address parameters
        and you'll get GPS-coordinates in return: street, number, zip, city, country.
      </p>
      <p>
        <a href="http://geocoder.squid.software/docs" target="_blank"
          >Read the full documentation here</a
        >
      </p>

      <h3>Pricing</h3>
      <table>
        <thead>
          <tr>
            <th class="right">Number of requests</th>
            <th class="left">Price per month</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="right">0 - 1.000</td>
            <td class="left">Free</td>
          </tr>
          <tr>
            <td class="right">1.000 - 10.000</td>
            <td class="left">€ 5,00 (ex. BTW)</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<style>
  h1 {
    margin-bottom: 50px;
  }
  .icon {
    width: 60px;
  }
  a {
    text-decoration: underline;
  }
  table {
    margin: 0 auto;
  }
  th.right,
  td.right {
    text-align: right;
  }
  th.left,
  td.left {
    text-align: left;
  }
  th,
  td {
    padding: 0 5px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    margin: 0 10%;
    flex-wrap: wrap;
  }
  @media (max-width: 1000px) {
    .flex {
      justify-content: center;
    }
  }
  .flex div {
    max-width: 400px;
  }
  @media (max-width: 1000px) {
    .flex div {
      margin-top: 50px;
    }
    .flex div:first-of-type {
      margin-top: 0;
    }
  }
</style>
